import { ServicePage } from '../ServicePage';

export default function Launch() {
  return (
    <ServicePage
      categoryKey="launch"
      heroImage="https://images.unsplash.com/photo-1760860992203-85ca32536788?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1800"
      overline="Hizmetlerimiz"
      headline="Açılış & Lansman"
      headlineAccent="İlk İzlenimler Kalıcıdır."
      intro="Markanızın hayata girişini ya da yeni bir ânın başlangıcını kutlamak söz konusu olduğunda, yalnızca birinci izlenim yapılabilir. İMER, açılış ve lansman etkinliklerinizi stratejik bir anlatışa dönüştürür."
      inclusions={[
        { title: 'Sahne & Marka Tasarımı', desc: 'Markanızı yansıtan etkileyici sahne ve mekân düzeni' },
        { title: 'Basın & Medya Koordinasyonu', desc: 'Basın daveti, basın bülteni ve medya karşılama hizmetleri' },
        { title: 'Kurgu & Sunum Tasarımı', desc: 'Etkileyici slayt ve kurgu üretimi' },
        { title: 'VIP & Influencer Yönetimi', desc: 'Davetli listesi ve VIP protokol yönetimi' },
        { title: 'Teknik Prodüksiyon', desc: 'Ses, ışık, LED ekran ve A/V sistemleri' },
        { title: 'Creatml Mekan Dekorasyonu', desc: 'Ürünü / markanızı öne çıkaran özel dekor çözümleri' },
        { title: 'Fotoğraf & çekim Hizmetleri', desc: 'Profesyonel çekim koordinasyonu' },
        { title: 'Etkinlik Günü Tam Koordinasyon', desc: 'Saatsel program ve saha yönetimi' },
      ]}
      processSteps={[
        { num: '01', title: 'Marka Analizi', desc: 'Markanızı, hedef kitlenizi ve lansmanla ulaşmak istediğiniz mesajı analiz ediyoruz.' },
        { num: '02', title: 'Konsept Geliştirme', desc: 'Etkinlik temasını, mekân konseptini ve deneyim mimarisini şekillendiriyoruz.' },
        { num: '03', title: 'Prodüksiyon Planla', desc: 'Tüm teknik, lojistik ve tedarikçi koordinasyonunu yönetiyoruz.' },
        { num: '04', title: 'Sahne Kurulumu', desc: 'Etkinlik öncesi tüm kurulum ve teknik testleri tamamlıyoruz.' },
        { num: '05', title: 'Lansman Günü', desc: 'Sahada tam ekiple günü yönetiyoruz. Her saniye planlandığı gibi ilerler.' },
      ]}
      signatureDetails={{
        title: 'Lansmanlar Yalnızca Bir Başlangıç Değildir',
        body: 'Bir lansman etkinliği, markanızın pazarında bırakacağı ilk izlenimi tanımlar. İMER, bu izlenimi etkileyici, akılda kalıcı ve stratejik bir biçimde şekillendirmek için tüm kapasitesiyle devreye girer.',
        list: [
          'Ürün lansman etkinlikleri',
          'Mağaza ve şube açılışları',
          'Marka yenileme lansmanları',
          'Basın konferansları',
          'Sektör etkinlikleri ve fuar katılımları',
        ],
        image: 'https://images.unsplash.com/photo-1644879131987-e0018885bdb3?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
      }}
      faqItems={[
        { q: 'Açılış etkinliği için bant kesşi dışında ne önerirsiniz?', a: 'Marka hikayenizi anlatan özel bir sahne kurgusu, görsel bir prodüksiyon anı ve basına yönelik özel bir deneyim alanı öneriyoruz.' },
        { q: 'Basın davetlisi koordinasyonu yapıyor musunuz?', a: 'Evet, basın listesi oluşturma, davetiye yollama ve etkinlik günü medya koordinasyonu hizmetimiz mevcuttur.' },
      ]}
    />
  );
}
